
export const GET_PROFILE_DATA_LOADING='GET_PROFILE_DATA_LOADING'
export const GET_PROFILE_DATA_SUCCESS='GET_PROFILE_DATA_SUCCESS'
export const GET_PROFILE_DATA_FAILED='GET_PROFILE_DATA_FAILED'

export const UPDATE_PROFILE_LOADING='UPDATE_PROFILE_LOADING'
export const UPDATE_PROFILE_SUCCESS='UPDATE_PROFILE_SUCCESS'
export const UPDATE_PROFILE_FAILED='UPDATE_PROFILE_FAILED'